import Vue from 'vue';
import { axiosMedForNgos } from '../utils/axios.util';

Vue.use({
    install: /** @param {import('vue').VueConstructor} Vue */ Vue => {
        Vue.prototype.$axiosMedForNgos = axiosMedForNgos;
    } },
);

